import EFCOAlert from '@/components/UI/svg/dg200/Icon/EFCOAlert';
import EFCOAlertH5 from '@/components/UI/svg/dg200/Icon/EFCOAlertH5';
import EFEngineOilAlert from '@/components/UI/svg/dg200/Icon/EFEngineOilAlert';
import EFEngineOilAlertH5 from '@/components/UI/svg/dg200/Icon/EFEngineOilAlertH5';
import EFFuelAlert from '@/components/UI/svg/dg200/Icon/EFFuelAlert';
import EFFuelAlertH5 from '@/components/UI/svg/dg200/Icon/EFFuelAlertH5';
import EFOverload from '@/components/UI/svg/dg200/Icon/EFOverload';
import EFOverloadH5 from '@/components/UI/svg/dg200/Icon/EFOverloadH5';
import EFTemperatureProtection from '@/components/UI/svg/dg200/Icon/EFTemperatureProtection';
import EFTemperatureProtectionH5 from '@/components/UI/svg/dg200/Icon/EFTemperatureProtectionH5';
import { useGlobal } from '@/utils/useGlobal';
import { TimelineMax, TweenMax } from 'gsap';
import css from './index.module.scss';
import IndexH5 from './indexH5';
import IndexPc from './indexPc';

export default function CardsIconJ() {
    const { useLang, isMobile, useEffect, useState } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');
    const Com = isMobile ? IndexH5 : IndexPc;
    const cards = [
        {
            icon: isMobile ? <EFCOAlertH5 /> : <EFCOAlert />,
            title: t('dg200.cardsIconJ_car1_title'),
            text: t('dg200.cardsIconJ_car1_text'),
        },
        {
            icon: isMobile ? <EFFuelAlertH5 /> : <EFFuelAlert />,
            title: t('dg200.cardsIconJ_car2_title'),
            text: t('dg200.cardsIconJ_car2_text'),
        },
        {
            icon: isMobile ? <EFEngineOilAlertH5 /> : <EFEngineOilAlert />,
            title: t('dg200.cardsIconJ_car3_title'),
            text: t('dg200.cardsIconJ_car3_text'),
        },
        {
            icon: isMobile ? <EFTemperatureProtectionH5 /> : <EFTemperatureProtection />,
            title: t('dg200.cardsIconJ_car4_title'),
            text: t('dg200.cardsIconJ_car4_text'),
        },
        {
            icon: isMobile ? <EFOverloadH5 /> : <EFOverload />,
            title: t('dg200.cardsIconJ_car5_title'),
            text: t('dg200.cardsIconJ_car5_text'),
        },
    ];

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    // 手机动画
    useEffect(() => {
        if (isMobile) {
        }
    }, []);

    // 桌面动画
    useEffect(() => {
        if (!isMobile) {
            const sceneA = new ScrollMagic.Scene({
                triggerElement: '#cardsIconJ_pc_trigger',
                offset: 0,
                triggerHook: 1,
                duration: 500,
            });
            const timeline = new TimelineMax();
            const tween1 = TweenMax.to('.cardsIconJ_pc .left .title', 0.5, { opacity: 0 });
            const tween2 = TweenMax.to('.cardsIconJ_pc .left .desc', 0.5, { opacity: 0 });
            timeline.add(tween1).add(tween2);
            sceneA.setTween(timeline);
            controller.addScene(sceneA);
        }
    }, []);

    return (
        <div className={`cardsIconJ ${css.cardsIconJ} ${isMobile ? 'cardsIconJ_h5' : 'cardsIconJ_pc'}`}>
            <Com cards={cards} />
            <div id="cardsIconJ_pc_trigger"></div>
        </div>
    );
}
